<main class="content d-flex flex-column vi-gap-24">
  <headline-text [headline]="'APPOI.PROPOSAL.HEADLINE' | translate"
                 [text]="'APPOI.PROPOSAL.DESCRIPTION' | translate"
  ></headline-text>
  <div>
    <mat-card>
      <mat-card-content>
        <appointment-details [appointment]="appointment" [hideAddToCalendar]="true"
                             [settings]="settings"></appointment-details>
      </mat-card-content>
      <mat-card-actions>
        <button (throttledClick)="confirm(false)"
                [gtmEventData]="{ 'decision': 'DECLINED' }"
                [gtmEventName]="'appointment_proposal_answered'"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                mat-flat-button>{{ ('APPOI.PROPOSAL.BUTTON_DECLINE_' + (appointment.serviceCallType || 'DEFAULT')) | translate }}
        </button>
        <button (throttledClick)="confirm(true)"
                [gtmEventData]="{ 'decision': 'ACCEPTED' }"
                [gtmEventName]="'appointment_proposal_answered'"
                [throttleTime]="5000"
                appPreventDoubleClick
                class="vi-button"
                color="primary"
                mat-flat-button>{{ 'APPOI.PROPOSAL.BUTTON_ACCEPT' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</main>
